import { render, staticRenderFns } from "./ModalSelectPatient.vue?vue&type=template&id=59cc9754&scoped=true"
import script from "./ModalSelectPatient.vue?vue&type=script&lang=js"
export * from "./ModalSelectPatient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59cc9754",
  null
  
)

export default component.exports